(function($){

    'use strict';

    theme.AssetsLoader.onPageLoaded(function() {
        if($(".blocks").length > 6){
            $(".blocks").addClass("hide-block");
            var blen = $(".blocks").length;
            var count = 6;
            $('.blocks').each(function (index) {
                if (index < 6) {
                    $(this).removeClass('hide-block')
                }
            });
            $(".load-more-blog").click(function () {
                if($(window).width() > 1025){
                    count = count + 3;
                } else {
                    count = count + 4;
                }
            
                $('.blocks').each(function (index) {
                    if (index < count) {
                        $(this).removeClass('hide-block')
                    } else {
                        return false;
                    }
                });
                if (blen <= count) {
                    $(".load-more-blog").hide();
                }
            });
        }
        else {
            $(".load-more-blog").hide();
        }
        
        $('.article__body a:not([href^="#"])').prop('target', '_blank');

        $("#Loadmore").on('click touchstart', function (e) {
            e.preventDefault();
            $(".gallery_item.d-none").slice(0,3).removeClass("d-none");
            if ($(".gallery_item.d-none").length == 0)
              $(this).addClass('d-none');
        });

        $( ".product-video-button" ).on( "click", function() {  
            $(this).removeClass('d-flex').addClass('d-none');
            $(this).parent('.product_info_video').find('.product-video-image').addClass('d-none');
              $(this).parent('.product_info_video').find('.product-video').removeClass('d-none');
        });

        if ($(document.body).hasClass('template-article')) {
            $('.header__content').append("<div id='scrollIndicator'/>")
            $(window).on('scroll resize', function (e) {
            $('#scrollIndicator').width(($(document).scrollTop()) / ($(document).height() - $(window).height()) *100+ "%")
            });

            let toc = $("#toc").append($('.article__body .rte > ul:first-of-type').clone())
            let blogImage = $('.article__body header + div');
            toc.css('margin-top', blogImage.position().top + blogImage.height() + 24 + "px");
        }

        let countDown = $("#countDown")
        if (countDown.length != 0) {
            try {
                let countDownDate = new Date(countDown.attr("data-sale-end") + " 00:00 " + (countDown.attr("data-discount") === "true" ? "CST" : "PST"));
                // Update the count down every 1 second
                var x = setInterval(function() {
                    // Find the distance between now and the count down date
                    var distance = countDownDate - new Date().getTime();

                    // Time calculations for days, hours, minutes and seconds
                    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    if (days == 0) {
                        countDown.find(".day").removeClass("d-flex").addClass("d-none");
                        if (hours == 0)
                            countDown.find(".hour").removeClass("d-flex").addClass("d-none");
                    } else
                        countDown.find("#days").html(days)

                    countDown.find("#hours").html(hours)
                    countDown.find("#minutes").html(minutes)
                    countDown.find("#seconds").html(seconds)

                    // If the count down is finished, write some text
                    if (distance < 0) {
                        clearInterval(x);
                        $(".campaign_counter").hide();
                    }
                }, 1000);
            } catch {
                console.error("Invalid date: " + countDown.attr("data-sale-end"));
            }
        }

        $("#popup-discount-btn").on("click", function(event) {
            event.preventDefault();
            let code = $("#popup-discount-code");
            navigator.clipboard.writeText(code.text());
            code.fadeTo(500, 0).fadeTo(500, 1);
        })

    });
})(jQueryTheme);